<template>
  <div class="repairman backdrop">
    <div class="repairman-time" v-if="this.appointTime === ''">
      <div>限定到达时间</div>
      <input type="text" placeholder="请选择预约时间" @click="selectData" v-if="orderTime == ''" v-model="date_time">
      <input type="text" placeholder="请选择预约时间" @click="selectData" v-else v-model="orderTime">
      <mt-datetime-picker ref="datePicker" type="datetime" v-model="pickerValue" @confirm="handleConfirm"></mt-datetime-picker>
    </div>
    <div class="common repairman-list">
      <div class="repairman-header">主维修员配置</div>
      <div class="repairman-list-block">
        <img class="headimg" :src="head_portrait">
        <div>
          <span>{{village_member_name}}</span>
          <span>{{tel}}</span>
        </div>
        <img @click="clickReplace(villageMemberListStr,id, village_member_name, tel, head_portrait)" class="selectimg" src="../../assets/images/repairman-replace.png">
      </div>
    </div>
    <div class="common repairman-list">
      <div class="repairman-header">协同维修员配置</div>
      <div class="repairman-list-block" v-if="newarray!==''" v-for="(r_keeper, r_keeper_key) in newarray" :key="r_keeper_key">
        <img class="headimg" :src="r_keeper.head_portrait">
        <div>
          <span>{{r_keeper.village_member_name}}</span>
          <span>{{r_keeper.tel}}</span>
        </div>
        <img class="selectimg" src="../../assets/images/repairman-del.png" @click="delRepairman(r_keeper.id)">
      </div>
      <div class="repairman-list-block" @click="CheckRepairman(villageMemberListStr,id, village_member_name, tel, head_portrait)">
        <img class="headimg" src="../../assets/images/repairman-add.png">
        <div>
          <span>添加协同维修员</span>
          <span>请选择</span>
        </div>
      </div>
    </div>
    <div class="btn-submit">
      <button @click="submit()">保存</button>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Repairman',
  metaInfo: {
    title: '维修师傅'
  },
  data () {
    return {
      date_time: '', // 报修预约时间
      villageMemberList: [],
      villageMemberListStr: '',
      newarray: [],
      addvillageMember: [],
      postVillageMember: [],
      pickerValue: new Date()
    }
  },
  computed: {
    ...mapState(['villageName', 'repairId', 'villageId', 'roomId', 'roomName', 'userId', 'setTime', 'appointTime', 'orderTime', 'appid', 'warningTime', 'usertel'])
  },
  created () {
    // 获取当前时间
    var mydate = new Date()
    var timestamp = mydate.setMinutes(mydate.getMinutes() + this.setTime)
    this.date_time = this.timestampToTime(timestamp)

    this.getVillageList()
    this.repair_id = this.$route.query.repair_id
    this.id = this.$route.query.id
    this.village_member_name = this.$route.query.name
    this.tel = this.$route.query.tel
    this.head_portrait = this.$route.query.head_portrait
    this.newarray = this.$route.query.newarray
    if (this.$route.query.newarray !== undefined) {
      this.newarray = JSON.parse(this.$route.query.newarray)
      for (let i = 0; i < this.newarray.length; i++) {
        if (this.newarray[i].id === this.id) {
          this.newarray.splice(i, 1)
          this.villageMemberListStr = JSON.stringify(this.newarray)
          // this.$set(this.newarray, i, '')
        }
      }
    } else {
      this.newarray = []
    }

    // this.villageMemberList = [
    //   {
    //     id: this.id,
    //     village_member_name: this.village_member_name,
    //     tel: this.tel,
    //     head_portrait: this.head_portrait
    //   }

    // ]
    this.villageMemberListStr = JSON.stringify(this.newarray)
  },
  methods: {
    ...mapMutations(['changeArgs']),
    getVillageList () {
      // 获取小区列表
      this.axios.get('/wechat/index/getUserVillageList/openid/' + this.openid + '/tel/' + this.usertel + '/authorizer_appid/' + this.appid)
        .then((res) => {
          if (res.data.status === 1) {
            this.villageMemberList = res.data.data
            console.log(res.data.data)
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    // 选择维修师傅
    CheckRepairman: function (villageMemberListStr, id, name, tel, headportrait) {
      console.log(villageMemberListStr)
      this.$router.push({name: 'CheckRepairman', query: {member: villageMemberListStr, id: id, name: name, tel: tel, head_portrait: headportrait}})
    },
    clickReplace: function (villageMemberListStr) {
      console.log(JSON.stringify(this.newarray))
      // this.$router.replace({name: 'SelectRepairman'})
      this.$router.push({name: 'SelectRepairman', query: {member: JSON.stringify(this.newarray)}})
    },
    clickAdd: function (e) {
      this.$router.replace({name: 'CheckRepairman'})
    },
    delRepairman: function (id) {
      for (let i = 0; i < this.newarray.length; i++) {
        if (this.newarray[i].id === id) {
          console.log(id + 'hjjjjj' + this.newarray[i].id)
          console.log(this.newarray.length)
          this.newarray.splice(i, 1)
          this.villageMemberListStr = JSON.stringify(this.newarray)
          // this.$set(this.newarray, i, '')
        }
      }
    },
    // 将时间戳转化为日期格式
    timestampToTime (timestamp) {
      var date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = (date.getMonth() + 1)
      var day = date.getDate()
      var hour = date.getHours()
      var minute = date.getMinutes()
      // var s = date.getSeconds()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      hour = hour > 9 ? hour : '0' + hour
      minute = minute > 9 ? minute : '0' + minute
      return `${year}-${month}-${day} ${hour}:${minute}`
    },
    // 获取当前时间
    getDate (type) {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      hour = hour > 9 ? hour : '0' + hour
      minute = minute > 9 ? minute : '0' + minute
      return `${year}-${month}-${day} ${hour}:${minute}`
    },
    // 打开时间选择器
    selectData () {
      this.$refs['datePicker'].open()
    },
    // 选择时间点击确定按钮
    handleConfirm (val) {
      let date = val
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      hour = hour > 9 ? hour : '0' + hour
      minute = minute > 9 ? minute : '0' + minute
      let resDate = year + '-' + month + '-' + day + ' ' + hour + ':' + minute
      this.date_time = resDate
      this.changeArgs({orderTime: this.date_time})
    },
    // 保存
    submit: function () {
      this.addvillageMember = [{
        level: 1,
        id: this.id,
        village_member_name: this.village_member_name,
        tel: this.tel,
        head_portrait: this.head_portrait
      }]
      console.log(this.addvillageMember)
      for (let i = 0; i < this.newarray.length; i++) {
        this.newarray[i].level = 2
      }
      console.log(this.newarray)
      this.postVillageMember = this.newarray.concat(this.addvillageMember)
      console.log(this.postVillageMember)

      if (this.appointTime === '') {
        if (this.orderTime === '') {
          this.changeArgs({orderTime: this.date_time})
        }
      } else {
        this.changeArgs({orderTime: this.appointTime})
      }

      var date1 = new Date(this.orderTime)
      var date2 = new Date(this.getDate())
      var s1 = date1.getTime()
      var s2 = date2.getTime()
      var total = s1 - s2
      console.log(total)
      var warningTime = this.warningTime * 60 * 1000
      console.log(warningTime)
      if (warningTime !== 0) {
        if (total < warningTime) {
          this.$messagebox({
            message: '剩余时间小于预警时间，是否继续保存？',
            closeOnClickModal: false,
            showCancelButton: true,
            confirmButtonText: '继续保存',
            cancelButtonText: '返回修改'
          }).then(action => {
            if (action === 'confirm') { // 确认的回调
              this.Appoint()
            }
          })
        } else {
          this.Appoint()
        }
      } else {
        this.Appoint()
      }
    },
    Appoint () {
      this.axios.post('/wechat/repair/Appoint', {
        repair_id: this.repairId,
        village_id: this.villageId,
        appoint_time: this.orderTime,
        user_id: this.userId,
        repair_keeper_list: this.postVillageMember
      }).then((res) => {
        if (res.data.status === 1) {
          this.sendRepairAssignedTemp()
          this.$router.replace({name: 'RepairDetail'})
        }
      })
    },
    // 模版消息
    sendRepairAssignedTemp () {
      this.axios.post('/wechat/index/sendRepairAssignedTemp/', {
        authorizer_appid: this.appid,
        village_id: this.villageId,
        repair_id: this.repairId,
        repair_keeper_list: this.postVillageMember
      }).then((res) => {
        if (res.data.status === 1) {
          console.log(res)
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  }
}
</script>
<style scoped>
.repairman-header {
  color: #000000;
  font-size: 15px;
  font-weight: bold;
  padding: 10px 0;
}
.repairman-list {
  padding: 5px 15px;
}
.repairman-list .repairman-list-block {
  display: flex;
  padding: 10px 0;
}
.repairman-list .repairman-list-block div {
  flex: 1;
  color: #000000;
  padding: 0 15px;
}
.repairman-list .repairman-list-block div:last-child {
  border-bottom: none;
}
.repairman-list .repairman-list-block div span {
  display: block;
}
.repairman-list .repairman-list-block div span:first-child {
  font-size: 15px;
  padding-top: 9px;
}
.repairman-list .repairman-list-block div span:last-child {
  font-size: 12px;
  color: #8c8c8c;
  padding-top: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.repairman-list .repairman-list-block .headimg {
  width: 59px;
  height: 59px;
  border-radius: 50%;
}
.repairman-list .repairman-list-block .selectimg {
  width: 23px;
  height: 23px;
  margin-top: 18px;
}
.btn-submit {
  width: 100%;
  text-align: center;
  margin-top: 15px;
}
.btn-submit button {
  background-color: #ffffff;
  color: #000000;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  border: none;
  outline: initial;
}
.repairman-time {
  display: flex;
  font-size: 14px;
  padding: 10px;
}
.repairman-time div {
  line-height: 30px;
}
.repairman-time input {
  border-radius: 5px;
  height: 30px;
  border: none;
  padding: 0 10px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Repair/Repairman.vue